<template>
  <v-card style='background: #f3f4f6; border: none' :width="$isMobile ? (windowInnerWidth * 0.98) - 80 : 734">
    <v-card-text>
      <div class='d-flex align-start'>
        <div>
          <div>
            <span
              style='color: #a100ff; font-size: 22px; font-weight: 700'>{{ headerTitle }}</span>
          </div>
          <div v-if='item.code === 200' class='mt-3'>
            <div class="prompt" style='color: #000000'>
              {{ language === 'chinese' ? '您已取消预订' : 'You have cancelled your reservation' }}
            </div>
            <div class='mt-2 place-detail' style='color: #000000'>
              <div class='font-weight-black'>
                <div v-if="language === 'chinese'" class='d-flex align-center'>
                  <div class='circle'></div>
                  地点：{{ item.cityName }}{{ item.cityName === '大连' ? '' : item.buildName
                  }}{{ item.roomName === 'King Landing' ? 'King\'s Landing' : item.roomName }}
                </div>
                <div v-else class='d-flex align-center'>
                  <div class='circle'></div>
                  Location：{{ item.cityValue }}{{ item.cityName === '大连' ? '' : item.buildingValue
                  }}{{ item.roomName === 'King Landing' ? 'King\'s Landing' : item.roomName }}
                </div>
                <div class='mt-0 d-flex align-center mt-1'>
                  <div class='circle'></div>
                  {{ language === 'chinese' ? '开始时间' : 'Start' }}：{{ getDateFromDate(item.start)
                  }}({{ calculateWeekday(item.start) }})
                </div>
                <div class='mt-1 d-flex align-center'>
                  <div class='circle'></div>
                  {{ language === 'chinese' ? '结束时间' : 'End' }}：{{ getDateFromDate(item.end)
                  }}({{ calculateWeekday(item.end) }})
                </div>
                <!--                <div class='mt-2 d-flex align-center'>-->
                <!--                  <div class='circle mr-2'></div>-->
                <!--                  时段：{{ getTimeFromDate(item.start) }}-{{ getTimeFromDate(item.end) }}-->
                <!--                </div>-->
              </div>
            </div>
          </div>
          <div v-else>
            <div class='mt-3' style='color: #000000; font-size: 16px'>
              {{ language === 'chinese' ? item.errorMsg : 'No record of your reservation was found.' }}
            </div>
          </div>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>
<script>
import { mdiAccountMultipleOutline, mdiMapMarkerRadiusOutline } from '@mdi/js'
import moment from 'moment'
import { getChineseWeekday } from '../util/ChatBotUtil.js'

export default {
  props: {
    item: {
      type: Object,
      default: () => {
      },
    },
    language: {
      type: String,
      default: 'chinese',
    },
  },
  computed: {
    headerTitle() {
      if (this.item.code === 200) {
        return this.language === 'chinese' ? '取消成功' : 'Cancel successfully'
      } else {
        return this.language === 'chinese' ? '取消失败' : 'Cancel failed'
      }
    },
    windowInnerWidth() {
      return window.innerWidth
    },
  },
  data() {
    return {
      icons: {
        mdiMapMarkerRadiusOutline,
        mdiAccountMultipleOutline,
      },
    }
  },
  methods: {
    getTimeFromDate(dateString) {
      return moment(dateString).format('HH:mm')
    },
    getDateFromDate(dateString) {
      return moment(dateString).format('YYYY-MM-DD HH:mm')
    },
    calculateWeekday(inputDate) {
      if (moment(inputDate, 'YYYY-MM-DD').isValid()) {
        const weekDay = moment(inputDate, 'YYYY-MM-DD').format('dddd')
        return this.language === 'chinese' ? getChineseWeekday(weekDay) : weekDay
      } else {
        return null
      }
    },
  },
}
</script>
<style scoped>
.image-grid {
  margin-top: 10px;
  margin-left: -5px;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(20px, 1fr));
  grid-template-rows: repeat(3, 1fr);
  grid-auto-flow: column;
}

/* 移动端样式 */
@media (max-width: 767px) {
  .prompt {
    font-size: 14px;
  }
  .place-detail {
    font-size: 13px;
  }
  .circle {
    margin-right: 4px;
    width: 12px;
    height: 12px;
    background: #a100ff;
    border-radius: 50%; /* 关键属性 */
  }
}

/* 桌面端样式 */
@media (min-width: 768px) {
  .prompt {
    font-size: 16px;
  }
  .place-detail {
    font-size: 15px;
  }
  .circle {
    margin-right: 8px;
    width: 12px;
    height: 12px;
    background: #a100ff;
    border-radius: 50%; /* 关键属性 */
  }
}
</style>
